import _ from 'lodash'
import useScript from './hooks/useScript'

function useJiraIssueCollector(userData) {
  const scriptSrc =
    'https://aiinovation.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/azc3hx/b/8/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-GB&collectorId=d8e92e2c'
  useScript(scriptSrc, !_.isEmpty(userData), () => {
    const fullname = _.get(userData, ['username'], '')
    const email = _.get(userData, ['email'], '')
    const source = _.get(userData, ['source'], '')
    window.ATL_JQ_PAGE_PROPS = {
      fieldValues: {
        fullname: `${fullname}:${source}`,
        email
      }
    }
  })
}

export default useJiraIssueCollector
